import { Box, Stack, Typography } from '@mui/material';
import { LocalHospital as LogoIcon } from '@mui/icons-material';

export function Logo() {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 34,
          height: 34,
          borderRadius: 1.5,
          bgcolor: 'rgba(37, 99, 235, 0.10)',
          color: 'primary.main',
        }}
      >
        <LogoIcon fontSize="small" />
      </Box>
      <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700, letterSpacing: '-0.01em' }}>
        케어허브 BGT
      </Typography>
    </Stack>
  );
}
